import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { tratarIsNullOrEmpty } from 'src/app/core/utils/utilities';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import {
  ICreateMotoristaExternoBody,
  IUpdateMotoristaExternoBody
} from 'src/app/services/MotoristaExternoService/motoristaExterno.model';
import { MotoristaExternoService } from 'src/app/services/MotoristaExternoService/motoristaExterno.service';
import {
  ICreateMotorista,
  IEditMotorista,
  IGetMotoristaById,
  IItems as IItemsMotorista
} from 'src/app/services/MotoristaService/motorista.model';
import { MotoristaService } from 'src/app/services/MotoristaService/motorista.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ViaCepService } from 'src/app/services/ViaCep/viacep.service';
import Swal from 'sweetalert2';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-usuario',
  templateUrl: './cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.scss']
})
export class CadastroUsuarioComponent implements OnInit, OnDestroy {
  private subscription$ = new Subscription();
  form = this._inicializarFormulario();
  activeRoute: string = '';
  isEditing: boolean = false;
  isLoading: boolean = false;
  pkMotorista: number = 0;
  disabledMotorista: boolean = false;
  title: string = 'Cadastro de Usuário';
  guid = generateUUID();
  isLengthValid = false;
  hasNumber = false;
  hasLowercase = false;
  hasUppercase = false;
  hasSpecialChar = false;
  passwordsMatch = false;
  isValid = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private motoristaService: MotoristaService,
    private motoristaExternoService: MotoristaExternoService,
    private swalAlert: SwalAlertService,
    private viaCepService: ViaCepService
  ) {}

  createPayload(): ICreateMotoristaExternoBody | IUpdateMotoristaExternoBody {
    return {
      NM_MTRT_EXTR: tratarIsNullOrEmpty(
        this.form.controls['NM_USUA_MTRT'].value
      ),
      TX_CPF_EXTR: tratarIsNullOrEmpty(this.form.controls['TX_CPF_MTRT'].value),
      TX_CNH_EXTR: tratarIsNullOrEmpty(this.form.controls['TX_CNH_MTRT'].value),
      NU_TELE_EXTR: tratarIsNullOrEmpty(
        this.form.controls['NU_TELE_MTRT'].value
      ),
      TX_MAIL_EXTR: tratarIsNullOrEmpty(
        this.form.controls['TX_MAIL_MTRT'].value
      ),
      TX_SENH_EXTR: tratarIsNullOrEmpty(this.form.controls['TX_SENH'].value),
      TX_ENDE_CEP_EXTR: tratarIsNullOrEmpty(
        this.form.controls['TX_ENDE_CEP_FUNC'].value
      ),
      TX_ENDE_RUA_EXTR: tratarIsNullOrEmpty(
        this.form.controls['TX_ENDE_RUA_FUNC'].value
      ),
      TX_ENDE_CDDE_EXTR: tratarIsNullOrEmpty(
        this.form.controls['TX_ENDE_CDDE_FUNC'].value
      ),
      TX_ENDE_ESTD_EXTR: tratarIsNullOrEmpty(
        this.form.controls['TX_ENDE_ESTD_FUNC'].value
      )
    };
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      NM_USUA_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_CPF_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      TX_CNH_MTRT: this.fb.control('', {
        nonNullable: true
      }),
      NU_TELE_MTRT: this.fb.control('', {
        nonNullable: true
      }),
      TX_MAIL_MTRT: this.fb.control('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          )
        ]
      }),
      NU_STTS_MTRT: this.fb.control(1),
      TX_ENDE_CEP_FUNC: this.fb.control(''),
      TX_ENDE_CDDE_FUNC: this.fb.control(''),
      TX_ENDE_ESTD_FUNC: this.fb.control(''),
      TX_ENDE_RUA_FUNC: this.fb.control(''),
      TX_SENH: this.fb.control(''),
      TX_SENH_CNFRM: this.fb.control('')
    });
    return form;
  }

  obterDados() {
    this.router.events.subscribe(() => {
      if (this.router.url.includes('edicao')) {
        this.isEditing = true;
        this.passwordsMatch = true;
        this.title = 'Editar Usuário';
        const idUsuario = Number(localStorage.getItem('id'));
        if (!idUsuario) return;
        this.isLoading = true;
        this.motoristaExternoService
          .GetMotoristaExternoById(idUsuario)
          .subscribe({
            next: res => {
              this.form.controls['NM_USUA_MTRT'].setValue(res.NM_MTRT_EXTR);
              this.form.controls['TX_CPF_MTRT'].setValue(res.TX_CPF_EXTR);
              this.form.controls['TX_CNH_MTRT'].setValue(res.TX_CNH_EXTR);
              this.form.controls['NU_TELE_MTRT'].setValue(res.NU_TELE_EXTR);
              this.form.controls['TX_MAIL_MTRT'].setValue(res.TX_MAIL_EXTR);
              this.form.controls['TX_ENDE_CEP_FUNC'].setValue(
                res.TX_ENDE_CEP_EXTR
              );
              this.form.controls['TX_ENDE_CDDE_FUNC'].setValue(
                res.TX_ENDE_CDDE_EXTR
              );
              this.form.controls['TX_ENDE_ESTD_FUNC'].setValue(
                res.TX_ENDE_ESTD_EXTR
              );
              this.form.controls['TX_ENDE_RUA_FUNC'].setValue(
                res.TX_ENDE_RUA_EXTR
              );
              this.form.controls['TX_SENH'].setValidators([]);
              this.form.controls['TX_SENH_CNFRM'].setValidators([]);
            },
            error: (err) => {
              if (err?.handled) {
                this.router.navigate(['home']);
                return;
              }
              this.swalAlert.showAlertOnConfirmNavigate(
                'Erro!',
                'Ocorreu um erro ao buscar os dados desse usuário.',
                'warning',
                'home',
                true
              );
            },
            complete: () => (this.isLoading = false)
          });
      }
    });
  }

  postDados(): void {
    if (!this.isEditing) {
      this.createMotorista();
    } else {
      this.editMotorista();
    }
  }

  createMotorista(): void {
    const payload = this.createPayload();
    this.motoristaExternoService.CreateMotoristaExterno(payload).subscribe({
      next: () => {
        this.swalAlert.showAlertOnConfirmNavigate(
          'Sucesso!',
          'Cadastro realizado com sucesso.',
          'success',
          'home',
          true
        );
      },
      error: () => {}
    });
  }

  editMotorista(): void {
    const payload = this.createPayload();
    const idMotorista = Number(localStorage.getItem('id'));
    this.isLoading = true;
    this.motoristaExternoService
      .UpdateMotoristaExterno(
        payload as IUpdateMotoristaExternoBody,
        idMotorista
      )
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.swalAlert.showAlertOnConfirmNavigate(
            'Sucesso!',
            'Edição realizada com sucesso.',
            'success',
            'home',
            true
          );
        },
        error: () => {
          this.isLoading = false;
        },
        complete: () => (this.isLoading = false)
      });
  }

  confirmacaoSenha() {
    const senha = this.form.controls['TX_SENH'].value ?? '';
    const novaSenha = this.form.controls['TX_SENH_CNFRM'].value;
    this.isLengthValid = senha.length >= 8;
    this.hasNumber = /\d/.test(senha);
    this.hasLowercase = /[a-z]/.test(senha);
    this.hasUppercase = /[A-Z]/.test(senha);
    this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
    this.passwordsMatch = senha === novaSenha;

    // if (!this.isEditing) {
    if (
      this.isLengthValid &&
      this.hasNumber &&
      this.hasLowercase &&
      this.hasUppercase &&
      this.hasSpecialChar &&
      this.passwordsMatch
    ) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
    // }
  }

  consultaCEP(): void {
    const cep = String(this.form.controls['TX_ENDE_CEP_FUNC'].value);

    if (cep.length >= 8) {
      this.viaCepService.GetBuscarCep(cep).subscribe(response => {
        this.form.controls['TX_ENDE_CDDE_FUNC'].setValue(response.localidade);
        this.form.controls['TX_ENDE_ESTD_FUNC'].setValue(response.uf);
        this.form.controls['TX_ENDE_RUA_FUNC'].setValue(response.logradouro);
      });
    }
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  ngOnInit(): void {
    this.obterDados();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  onVoltar(): string {
    return '';
  }
}
